import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { ReactComponent as KofiIcon } from "assets/icons/external/kofi_s_logo_nolabel.svg";
import { ReactComponent as PatreonIcon } from "assets/icons/external/patreon-icon.svg";
import { ReactComponent as VenmoIcon } from "assets/icons/external/venmo-icon.svg";

import Crypto from "./Crypto";
import SvgIcon from "@mui/material/SvgIcon";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  useTheme,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SupportTile from "shared/SupportTile";

import KofiQRCode from "assets/icons/external/Ko-fi-QR.png";
import PatreonQrCode from "assets/icons/external/Patreon-QR.png";
import VenmoQrCode from "assets/icons/external/Venmo-QR.png";
import { Link } from "react-router-dom";
import LaunchIcon from "@mui/icons-material/Launch";

const fiatSupportOptions = [
  {
    name: "Ko-fi",
    brandIcon: KofiIcon,
    link: "https://ko-fi.com/tenkizora",
    qRCode: KofiQRCode,
    hide: { address: true, name: true },
  },
  {
    name: "Patreon",
    brandIcon: PatreonIcon,
    link: "https://patreon.com/Tenkizora",
    qRCode: PatreonQrCode,
    hide: { address: true, name: true },
  },
  {
    name: "Venmo",
    brandIcon: VenmoIcon,
    link: "",
    qRCode: VenmoQrCode,
    hide: { address: true, name: true },
  },
];

const Support = () => {
  const iconWidth = "320px";
  const theme = useTheme();
  const linkStyles = {
    color: theme.palette.secondary.main,
    fontWeight: "bold",
    textDecoration: "none",
    ":hover": {
      color: theme.palette.primary.light,
    },
  };

  return (
    <Box minWidth="320px" maxWidth="1024px" m="0 auto" paddingTop={2}>
      <Stack textAlign="start" spacing={2}>
        <Paper sx={{ padding: 2 }}>
          <Typography variant="h4" component="h1">
            Support
          </Typography>

          <Typography variant="body1" component="p" m={1}>
            While our releases are free for all, we still have bills to pay. If
            you are enjoying our releases, consider supporting us to so that we
            can keep the servers alive and help us continue bringing quality
            translations to you.
          </Typography>

          <Typography component="p" m={1}>
            There are multiple ways you can support us since we take a variety
            of payment methods, but if there is a method you prefer but it is
            not listed, you can contact us directly to see if we can figure
            something out.
          </Typography>
        </Paper>

        <Paper sx={{ padding: 2 }}>
          <Typography variant="h4" component="h2">
            Contribute
          </Typography>

          {fiatSupportOptions.map((option, index) => (
            <Accordion elevation={0} key={`${option.name}-${index}`}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon color="primary" />}
                aria-controls={`${option.name}-panel`}
                id={`${option.name}-panel`}
              >
                <Stack direction="row" alignItems="center" spacing={1}>
                  <SvgIcon
                    component={option.brandIcon}
                    inheritViewBox
                    fontSize="large"
                  />
                  <Typography variant="h4">{option.name}</Typography>
                </Stack>
              </AccordionSummary>
              <AccordionDetails>
                <Stack alignItems={"center"}>
                  <Typography>
                    Support us on{" "}
                    {option.link && option.link !== "" ? (
                      <Link
                        to={option.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ ...linkStyles }}
                      >
                        {option.name} <LaunchIcon fontSize="small" />
                      </Link>
                    ) : <span style={{ fontWeight: 'bold' }}>{option.name}</span>}
                  </Typography>
                  <Box width={`${300}px`} height={`${360}px`}>
                    <SupportTile
                      name={option.name}
                      address={option.link}
                      qrCode={option.qRCode}
                      hide={{ name: true, address: true }}
                    />
                  </Box>
                </Stack>
              </AccordionDetails>
            </Accordion>
          ))}
        </Paper>

        <Paper>
          <Accordion elevation={0}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon color="primary" />}
              aria-controls="crypto-panel"
              id="crypto-panel-header"
            >
              <Stack>
                <Typography variant="h4" component="h2">
                  Digital Currency
                </Typography>
              </Stack>
            </AccordionSummary>
            <AccordionDetails sx={{ marginBottom: 5 }}>
              <Typography variant="body1" sx={{ paddingTop: 2 }}>
                If centrally issued fiat currency is not for you and crypto is
                more your thing, we have several crypto addresses to which you
                can donate.
              </Typography>
              <Crypto />
            </AccordionDetails>
          </Accordion>
        </Paper>
      </Stack>
    </Box>
  );
};

export default Support;
